import styled from 'styled-components'
import Flex from 'components/Flex'

export const ShortlistDiv = styled.div`
  font-family: Plus Jakarta Sans;
  font-size: 20px;
  font-weight: 500;
  letter-spacing: 0em;
  text-align: center;
  color: #010e30;
  width: 451px;
  margin-top: 15px;
  margin-bottom: 15px;
`
export const UploadMsgFlex = styled(Flex)`
  height: 100%;
`
